import { useContext } from 'react';
import { GlobalEditContext } from '../contexts';

export function useGlobalEdit() {
  const { globalEditing, setGlobalEditing } = useContext(GlobalEditContext);

  return { globalEditing, setGlobalEditing };
}
